<template>
  <div class="" id="app">
    <router-view name="header-top"></router-view>
    <!-- <img src="./assets/logo.png"> -->
    <div class="container-fluid">
      <router-view></router-view>
    </div>
    <router-view name="header-bottom"></router-view>
  </div>
</template>

<script>
import Header from './components/Header.vue';
export default {
  components: {
    appHeader: Header
  },
  name: 'app',
  data: () => {
    return {
      // user: this.$root.$data
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style lang="css">

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif, "SimHei", "KaiTi";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left; color: #2c3e50;
  margin-top: 0;
  /* background-color: #f8f8f8; */
  background-color: 000000;
  /* padding-right: 15px; */
  /* padding-left: 15px; */
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

a {
  color: #292b2c;
}
</style>



// WEBPACK FOOTER //
// App.vue?2638fa44